{
  "tradingView": {
    "pre": "Пре",
    "post": "Пост"
  }
}
